import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { dt } from "../../../themes/redesignTokens";

export interface FormCardProps {
  children: React.ReactNode;
  animation?: string;
  animationDelay?: string;
  sx?: SxProps<Theme>;
}

const FormCard: React.FC<FormCardProps> = ({
  children,
  animation = "fadeUp 0.5s cubic-bezier(0.4,0,0.2,1) both",
  animationDelay,
  sx,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: dt.cardBg,
        borderRadius: dt.radius,
        border: `1px solid ${dt.cardBorder}`,
        boxShadow: dt.cardShadow,
        p: { xs: 2.5, md: 4 },
        display: "flex",
        flexDirection: "column",
        gap: 3,
        animation,
        animationDelay,
        ...((sx as Record<string, unknown>) || {}),
      }}
    >
      {children}
    </Box>
  );
};

export default FormCard;
